// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/email.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.centralised-contact-us-form{
    width: 100%;
}
.contact-us-container{
    width: 100%;
}
.contact-us-section{
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.product-contact-us{
    width: 100%;
    min-height: 300px;
    background-color: #F9F9F9;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
    border-radius: 2px;
    display: inline-block;
}

.product-contact-us-ip{
    border: none; /* Remove default border */
    outline: none; /* Remove default outline */
    background: none; /* Remove default background */
    padding: 0; /* Remove default padding */
    font-family: inherit; /* Use the parent font */
    font-size: inherit; /* Use the parent font size */
    border: solid 1px #D9D9D9;
    color:black;
    opacity: 0.6;
    text-align: center;
    margin: auto;
    width: 100%;
    padding: 10px 20px;
    margin-top: 10px;
    background-color: white;
}

.product-contact-us-ip-text-area{
    border: none; /* Remove default border */
    outline: none; /* Remove default outline */
    background: none; /* Remove default background */
    padding: 0; /* Remove default padding */
    font-family: inherit; /* Use the parent font */
    font-size: inherit; /* Use the parent font size */
    border: solid 1px #D9D9D9;
    color:black;
    opacity: 0.6;
    text-align: center;
    margin: auto;
    width: 100%;
    padding: 10px 20px;
    margin-top: 10px;
    min-height: 100px;
    background-color: white;
}

.technical-support{
    width: 40%;
    min-height: 300px;
    background-color: #F9F9F9;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
    border-radius: 2px;
}

.contactus-title-container{
    font-size: 20px;
    color: black;
    align-items: center;
    margin: auto;
    width: -moz-fit-content;
    width: fit-content;
}
.modal-close-button-container{
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.modal-close{
    background-color: black;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    margin-top: 5px;
    margin-right: 5px;
}
.contactus-icon-container{
    height: 50px;
    width: 50px;
    margin: auto;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
}


.contacus-tagline{
    width: 70%;
    margin: auto;
    font-weight: 600;
    opacity: 0.6;
    text-align: center;
}

.contact-us-form{
    width: 70%;
    margin: auto;
}

.contact-us-btn{
    margin: auto;
    color: white;
    padding: 10px 50px;
    background-color: #0094DC;
    border-radius: 20px;
    width: -moz-fit-content;
    width: fit-content;
    margin-bottom: 10px;
}

.center-text-align{
    width: -moz-fit-content;
    width: fit-content;
    align-items: center;
    margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/ContactUsForm/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,8CAA8C;IAC9C,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,YAAY,EAAE,0BAA0B;IACxC,aAAa,EAAE,2BAA2B;IAC1C,gBAAgB,EAAE,8BAA8B;IAChD,UAAU,EAAE,2BAA2B;IACvC,oBAAoB,EAAE,wBAAwB;IAC9C,kBAAkB,EAAE,6BAA6B;IACjD,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,YAAY,EAAE,0BAA0B;IACxC,aAAa,EAAE,2BAA2B;IAC1C,gBAAgB,EAAE,8BAA8B;IAChD,UAAU,EAAE,2BAA2B;IACvC,oBAAoB,EAAE,wBAAwB;IAC9C,kBAAkB,EAAE,6BAA6B;IACjD,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,yBAAyB;IACzB,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,uBAAkB;IAAlB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,yDAA8C;IAC9C,4BAA4B;IAC5B,sBAAsB;AAC1B;;;AAGA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".centralised-contact-us-form{\n    width: 100%;\n}\n.contact-us-container{\n    width: 100%;\n}\n.contact-us-section{\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n}\n\n.product-contact-us{\n    width: 100%;\n    min-height: 300px;\n    background-color: #F9F9F9;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;\n    border-radius: 2px;\n    display: inline-block;\n}\n\n.product-contact-us-ip{\n    border: none; /* Remove default border */\n    outline: none; /* Remove default outline */\n    background: none; /* Remove default background */\n    padding: 0; /* Remove default padding */\n    font-family: inherit; /* Use the parent font */\n    font-size: inherit; /* Use the parent font size */\n    border: solid 1px #D9D9D9;\n    color:black;\n    opacity: 0.6;\n    text-align: center;\n    margin: auto;\n    width: 100%;\n    padding: 10px 20px;\n    margin-top: 10px;\n    background-color: white;\n}\n\n.product-contact-us-ip-text-area{\n    border: none; /* Remove default border */\n    outline: none; /* Remove default outline */\n    background: none; /* Remove default background */\n    padding: 0; /* Remove default padding */\n    font-family: inherit; /* Use the parent font */\n    font-size: inherit; /* Use the parent font size */\n    border: solid 1px #D9D9D9;\n    color:black;\n    opacity: 0.6;\n    text-align: center;\n    margin: auto;\n    width: 100%;\n    padding: 10px 20px;\n    margin-top: 10px;\n    min-height: 100px;\n    background-color: white;\n}\n\n.technical-support{\n    width: 40%;\n    min-height: 300px;\n    background-color: #F9F9F9;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;\n    border-radius: 2px;\n}\n\n.contactus-title-container{\n    font-size: 20px;\n    color: black;\n    align-items: center;\n    margin: auto;\n    width: fit-content;\n}\n.modal-close-button-container{\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n.modal-close{\n    background-color: black;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 10px;\n    margin-top: 5px;\n    margin-right: 5px;\n}\n.contactus-icon-container{\n    height: 50px;\n    width: 50px;\n    margin: auto;\n    background-image: url(\"/src/assets/email.svg\");\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n\n.contacus-tagline{\n    width: 70%;\n    margin: auto;\n    font-weight: 600;\n    opacity: 0.6;\n    text-align: center;\n}\n\n.contact-us-form{\n    width: 70%;\n    margin: auto;\n}\n\n.contact-us-btn{\n    margin: auto;\n    color: white;\n    padding: 10px 50px;\n    background-color: #0094DC;\n    border-radius: 20px;\n    width: fit-content;\n    margin-bottom: 10px;\n}\n\n.center-text-align{\n    width: fit-content;\n    align-items: center;\n    margin: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
